/* Quick Size Hover - injects variant buttons on .product-card on the HOME page only.
   On click: adds variant to cart and lets the Tinker theme handle the drawer/refresh. */
(function () {
  if (window.__qshLoaded) return;
  window.__qshLoaded = true;

  // ----- Scope to the home page only -----
  function isHomePage() {
    var main = document.querySelector('#MainContent');
    if (main && main.dataset && main.dataset.template === 'index') return true;
    var path = (window.location && window.location.pathname) || '/';
    return path === '/' || /^\/(\?.*)?$/.test(path);
  }
  if (!isHomePage()) return;

  var productCache = {};
  var pendingFetches = {};

  // ----- Toast -----
  function ensureToast() {
    var t = document.getElementById('qsh-toast');
    if (t) return t;
    t = document.createElement('div');
    t.id = 'qsh-toast';
    t.className = 'qsh-toast';
    t.setAttribute('role', 'status');
    t.setAttribute('aria-live', 'polite');
    document.body.appendChild(t);
    return t;
  }
  function showToast(msg, isError) {
    var t = ensureToast();
    t.textContent = msg;
    t.classList.toggle('is-error', !!isError);
    t.classList.add('is-visible');
    clearTimeout(t._hideTimer);
    t._hideTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 2800);
  }

  // ----- Product fetch (cached) -----
  function fetchProduct(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    if (pendingFetches[handle]) return pendingFetches[handle];
    pendingFetches[handle] = fetch('/products/' + handle + '.js', { credentials: 'include' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (p) { productCache[handle] = p; delete pendingFetches[handle]; return p; })
      .catch(function (err) { delete pendingFetches[handle]; throw err; });
    return pendingFetches[handle];
  }

  function getHandleFromCard(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var href = link.getAttribute('href') || '';
    var m = href.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function getSizeOptionIndex(product) {
    if (!product.options || !product.options.length) return -1;
    for (var i = 0; i < product.options.length; i++) {
      var name = (product.options[i] || '').toString().toLowerCase();
      if (name.indexOf('size') !== -1 || name.indexOf('taille') !== -1) return i;
    }
    return -1;
  }

  // ----- Overlay -----
  function buildOverlay(card, product) {
    if (card.querySelector('.qsh-overlay')) return;
    if (!product.variants || product.variants.length === 0) return;

    var overlay = document.createElement('div');
    overlay.className = 'qsh-overlay';

    var hasOnlyDefault = product.variants.length === 1 && (
      product.variants[0].title === 'Default Title' ||
      product.variants[0].title === 'Titre par défaut'
    );

    if (hasOnlyDefault) {
      var v = product.variants[0];
      if (!product.available) return;
      var qa = document.createElement('button');
      qa.type = 'button';
      qa.className = 'qsh-quick-add';
      qa.textContent = 'Ajouter au panier';
      qa.setAttribute('data-variant-id', v.id);
      qa.setAttribute('data-product-url', '/products/' + product.handle);
      overlay.appendChild(qa);
    } else {
      var sizeIdx = getSizeOptionIndex(product);
      product.variants.forEach(function (v) {
        var label = (sizeIdx >= 0 && v.options && v.options[sizeIdx]) ? v.options[sizeIdx] : v.title;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'qsh-size' + (v.available ? '' : ' is-unavailable');
        btn.textContent = label;
        btn.setAttribute('data-variant-id', v.id);
        btn.setAttribute('data-product-url', '/products/' + product.handle);
        btn.setAttribute('title', v.title + (v.available ? '' : ' (sold out)'));
        if (!v.available) btn.setAttribute('aria-disabled', 'true');
        overlay.appendChild(btn);
      });
    }

    var link = card.querySelector('.product-card__link');
    var mediaContainer = card.querySelector('.product-card__media, slideshow-component, .product-media-container');
    var target = mediaContainer && link && link.contains(mediaContainer) ? link : (mediaContainer || card);
    if (getComputedStyle(target).position === 'static') target.style.position = 'relative';
    target.appendChild(overlay);
  }

  // ----- Cart drawer fallback opener -----
  function openCartDrawerFallback() {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return;
    // Skip if already open
    var dlg = drawer.querySelector('dialog');
    if (dlg && dlg.hasAttribute('open')) return;
    try { if (typeof drawer.open === 'function') { drawer.open(); return; } } catch (e) {}
    try { if (typeof drawer.showDialog === 'function') { drawer.showDialog(); return; } } catch (e) {}
    try { if (dlg && typeof dlg.showModal === 'function') { dlg.showModal(); return; } } catch (e) {}
  }

  // ----- Add to cart -----
  function addToCart(variantId, btn) {
    if (!variantId) return;
    btn && btn.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }),
      credentials: 'include'
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (err) { throw err; });
      return r.json();
    }).then(function (data) {
      return fetch('/cart.js', { credentials: 'include' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          // Dispatch the proper cart:update event - Tinker's components handle the rest:
          //   - cart-items-component re-renders the drawer via sectionRenderer.renderSection
          //   - cart-drawer-component auto-opens (has auto-open attribute)
          //   - cart-icon updates the count badge
          try {
            var ev = new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                sourceId: 'quick-size-hover',
                data: {
                  source: 'quick-size-hover',
                  itemCount: cart.item_count,
                  variantId: variantId
                }
              }
            });
            document.dispatchEvent(ev);
          } catch (e) {}

          // Safety fallback: if auto-open didn't trigger for some reason, open the drawer manually after a tick
          setTimeout(openCartDrawerFallback, 250);

          var title = (data.product_title || data.title || 'Article')
            + (data.variant_title && data.variant_title !== 'Default Title' ? ' (' + data.variant_title + ')' : '');
          showToast('Ajouté: ' + title);
        });
    }).catch(function (err) {
      var msg = (err && err.description) || (err && err.message) || 'Erreur ajout au panier';
      showToast(msg, true);
    }).finally(function () {
      btn && btn.classList.remove('is-loading');
    });
  }

  // ----- Card scanning -----
  function processCard(card) {
    if (card.dataset.qshDone === '1') return;
    card.dataset.qshDone = '1';
    var handle = getHandleFromCard(card);
    if (!handle) return;
    fetchProduct(handle).then(function (p) { buildOverlay(card, p); }).catch(function () {});
  }
  function processAllCards() {
    document.querySelectorAll('.product-card').forEach(processCard);
  }

  // Click delegate
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.qsh-size, .qsh-quick-add');
    if (!btn) return;
    if (btn.classList.contains('is-unavailable')) {
      e.preventDefault();
      var url = btn.getAttribute('data-product-url');
      if (url) window.location.href = url;
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    addToCart(btn.getAttribute('data-variant-id'), btn);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processAllCards);
  } else {
    processAllCards();
  }

  var mo = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      for (var j = 0; j < mutations[i].addedNodes.length; j++) {
        var node = mutations[i].addedNodes[j];
        if (node.nodeType !== 1) continue;
        if (node.classList && node.classList.contains('product-card')) processCard(node);
        else if (node.querySelectorAll) node.querySelectorAll('.product-card').forEach(processCard);
      }
    }
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();
